import { useEffect, useRef, useState } from "react";

export const CountUp = ({ to, suffix = "", duration = 1.8, className = "" }) => {
  const ref = useRef(null);
  const [val, setVal] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let raf;
    let timeout;
    let started = false;

    const run = () => {
      if (started) return;
      started = true;
      const t0 = performance.now();
      const tick = (now) => {
        const p = Math.min((now - t0) / (duration * 1000), 1);
        const eased = 1 - Math.pow(1 - p, 4);
        setVal(Math.round(to * eased));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
      timeout = setTimeout(() => {
        cancelAnimationFrame(raf);
        setVal(to);
      }, duration * 1000 + 250);
    };

    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          run();
          obs.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    obs.observe(el);

    return () => {
      obs.disconnect();
      cancelAnimationFrame(raf);
      clearTimeout(timeout);
    };
  }, [to, duration]);

  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
};
